<template>
  <div id="GroundStation">
  <section class="con2" :class="{on:classActive}">
    <div class="con2_bg"><img src="../../assets/image/con2_2.png"></div>
    <figure>
        <p class="con2_1"><span data-lang="con_title_ground_station">Ground Station</span></p>
        <p class="con2_2"><span data-lang="con_sub_title_ground_station">In order to control and receive data from satellites and launch vehicles, ground stations have to be installed in different areas down the ground. With advances in satellite technology and increasing demand for satellite data, the number of satellite launches has multiplied in the past few years, and ground stations for communication with launched satellites have begun to increase accordingly. </span></p>
        <p class="con2_3"></p>
        <p class="con2_4"><span data-lang="con_text_ground_station">To serve more customer satellites, it is important to have a wide network in the ground by establishing own infrastructure or renting the capacity of an existing antenna by paying a certain fee. This new business concept called ‘Ground Station as a Service (GSaaS)’ was then developed and some companies have been constructing these stations even without their own satellites just to provide the service to the satellite owners. A polar orbiting LEO satellite rotates the earth more than 10 times a day passing the North and South poles, and therefore communicate with the ground station installed in the polar region each time it rotates, securing a high capacity of more than 10 passes a day. </span></p>
    </figure>
  </section>
  </div>
</template>

<script>
import $ from "jquery"

export default {
  name: "GroundStation",
  data: ()=> ({
    myScroll: null,
    classActive: false,
  }),
  props: ['nowScroll'],
  watch: {
    nowScroll(newData) {
      this.textToggle(newData)
    }
  },
  mounted() {
    this.myScroll = $('#GroundStation').offset().top
  },
  methods: {
    textToggle(data) {
      if(data >= (this.myScroll - 500) && data <= (this.myScroll + 600)) {
        this.classActive = true
      } else {
        this.classActive = false
      }
    }
  }
}
</script>

<style scoped>

</style>